import { State } from '@/store/store'
import { UserStatus } from '@/services/userInterface'
export interface IUserList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: IUser[]
}

export interface IUser {
  _id: string,
  roleId: string,
  sign: string,
  centerId?: string,
  email: string,
  phone: string,
  prefix: string,
  firstname: string,
  lastname: string,
  idCard: string,
  lineId: string,
  birthdate: string,
  address: {
    address: string,
    country: string,
    district: string,
    elevation: number,
    geocode: string,
    postcode: string,
    province: string,
    subdistrict: string,
    location: string,
  }
  map: {
    lat: number,
    lon: number,
  }
  status: UserStatus,
  profile?: string,
  metadata?: {
    profile?: string,
    caregiverId?: string,
    nationality?: string,
    ethnicity?: string,
    religion?: string,
    language?: string[],
    experience?: string,
    charisma?: string,
    graduate?: string,
    status?: string,
    excludeDate?: string[],
    caregiverLevel?: number,
  }
  createdAt?: number,
  updatedAt?: number,
}

export class UserState {
  public list: IUserList
  public listCaregiver: IUserList
  public listLeader: IUserList
  public listStaff: IUserList
  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.listCaregiver = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.listLeader = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.listStaff = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
  }
}

export default UserState
